import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { FormTitle } from '../../../commonComponents/FormTitle'
import List from '../../../commonComponents/List'
import SupportingDocumentDetails from '../headerTab/supportingDocumentDetails'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import { TranslateContext } from '../TranslateContext'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'

const SupportingDocuments = (props) => {
  const key = 'supportingDoc'
  const { merchandiseId, invoiceId, lineItemIndex } = props
  const supportingDocList =useSelector((state) => state.InvoicesReducer.lineItems[invoiceId][lineItemIndex]?.supportingDoc) || []
  const {isLoading,AddItem,deleteItem,updateItem,saveItem, copyData}=useMultipleMerchandiseItem({tableName:key,invoiceId,merchandiseId});


  const renderItem = useCallback(
    (item) => {
      return (
        <SupportingDocumentDetails
          key={item.id}
          item={item}
          updateData={updateItem}
          deleteData={deleteItem}
          saveData={saveItem}
          isItemsTab={true}
          copyData={copyData}
        />
      )
    },
    [updateItem, deleteItem,saveItem,copyData]
  )

  const translate = React.useContext(TranslateContext).translate

  return (
    <Form.Group className='float-container mb-2'>
      <FormTitle boxNumber='2/3' title={translate('SUPPORTING_DOCS', {ns:["default", "lineItem", "header"]})}></FormTitle>
      <List dataSource={supportingDocList} renderItem={renderItem} />

      {isLoading && <CustomLoader />}
      {supportingDocList?.length < 99 && (
        <AddBtn id={`supportingDocs-add-${invoiceId}-${merchandiseId}`} onClick={AddItem} text={translate("ADD")}></AddBtn>
      )}
    </Form.Group>
  )
}

export default React.memo(SupportingDocuments)
